/**
 * Surface Listing — Interactivity API store extension.
 *
 * Registers the shared surface-filters store namespace so this block's directives
 * (data-wp-style--order, data-wp-bind--hidden, data-wp-text, data-wp-class)
 * can resolve the callbacks defined in surface-filters/view.ts.
 */

import { store } from "@wordpress/interactivity";

store("byggma-brann-og-lyd/surface-filters", {});
